module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/ponderosa_bw-p-800-9c9df3e268cca0f946d8edda309d2211.jpg";